import Select from "react-select";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {GetKaryawanMinV2, getMinKaryawanCuti, karyawanSelector} from "./karyawanSlice";
import Loading from "../../../components/loading/Loading";

export function KaryawanSelectorBuilder(props) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(GetKaryawanMinV2({search: ""}));
    }, [])

    const karyawan = useSelector(karyawanSelector);
    if (!karyawan) {
        return <Loading/>;
    } else {
        let ids = null
        if (props.value) {
            ids = karyawan.minKaryawan.find(x => x.value === props.value);
        }
        return (
            <>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className={!props.noTlpn ? "w-full px-3 md:mb-0 mb-6" : "w-full px-3 md:w-1/2 md:mb-0 mb-6"}>
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Karyawan
                        </label>
                        <div className="inline-block relative w-full  ">
                            <Select
                                value={karyawan.minKaryawan.filter(
                                    ({value}) => value === props.value
                                )}
                                name="Nik"
                                className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
                                onChange={(text) => {
                                    props.onChange(text.value, "Nik")
                                }
                                }
                                options={karyawan.minKaryawan}
                            />
                        </div>
                    </div>
                    {ids && props.noTlpn ? <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Nomor Tlpn
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.NomorTelepon}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-2.5 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />

                        </div>
                    </div> : <></>}
                </div>
                {ids ? <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Jabatan
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.NamaJabatan}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />

                        </div>
                    </div>
                    <div className="w-full md:w-1/2 px-3 md:mb-0">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Bagian
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.NamaBagian}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />
                        </div>
                    </div>
                </div> : <></>
                }
            </>
        )
    }
}

export function KaryawanSelectorCutiBuilder(props) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getMinKaryawanCuti({search: ""}));
    }, [])
    const karyawan = useSelector(karyawanSelector);
    if (!karyawan) {
        return <Loading/>;
    } else {
        let ids = null
        if (props.value) {
            ids = karyawan.minDataCuti.find(x => x.value === props.value);
        }
        return (
            <>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className={!props.noTlpn ? "w-full px-3 md:mb-0 mb-6" : "w-full px-3 md:w-1/2 md:mb-0 mb-6"}>
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Karyawan
                        </label>
                        <div className="inline-block relative w-full  ">
                            <Select
                                value={karyawan.minKaryawan.filter(
                                    ({value}) => value === props.value
                                )}
                                name="Nik"
                                className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
                                onChange={(text) => {
                                    props.onChange(text.value, "Nik")
                                }
                                }
                                options={karyawan.minDataCuti}
                            />
                        </div>
                    </div>
                    {ids && props.noTlpn ? <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Saldo Cuti
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.SisahCuti}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-2.5 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />

                        </div>
                    </div> : <></>}
                </div>
                {ids ? <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 md:mb-0 mb-6">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Jabatan
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.NamaJabatan}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />

                        </div>
                    </div>
                    <div className="w-full md:w-1/2 px-3 md:mb-0">
                        <label
                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Bagian
                        </label>
                        <div className="inline-block relative w-full  ">
                            <input
                                value={ids.NamaBagian}
                                className={"appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"}
                                type="text"
                                disabled={true}
                            />
                        </div>
                    </div>
                </div> : <></>
                }
            </>
        )
    }
}
